import React from "react";

const NoCopyWrapper = ({ children, className = "" }) => {
  return (
    <div
      className={`no-copy ${className}`}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      onDoubleClick={(e) => e.preventDefault()}
    >
      {children}
      <style jsx>{`
        .no-copy {
          user-select: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
      `}</style>
    </div>
  );
};

export default NoCopyWrapper;
